export default __webpack_public_path__ + "static/article-how-aussie-dollar-affects-your-travel-in-2017-56aba820e9a7878015ac6cba73ccb992.jpg";